import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  ADD_RECIPIENT_ASYNC,
  CHANGE_SELECTION_DATA,
  GENERAL_SETTINGS_REQUEST_ASYNC,
  GET_CANDIDATES_ASYNC,
  GET_RECIPIENTS_ASYNC,
  GET_TAGS_ASYNC,
  REMOVE_RECIPIENT_ASYNC,
  RESET_SIMULATOR,
  SET_CANDIDATES,
  SET_CANDIDATES_PAGE,
  SET_RECIPIENTS_PAGE,
  SET_TAGS,
  SET_TAGS_PAGE,
  UPDATE_GENERAL_SETTINGS_REQUEST,
} from './constants'

const DEFAULT_SELECTION_DATA = {
  selectionIds: [],
  allItems: false,
}

export default function () {
  const initialState = {
    loader: false,
    data: {},
    error: null,
    recipientList: {
      data: {
        items: [],
        meta: {},
      },
      selectionData: DEFAULT_SELECTION_DATA,
      loader: false,
      error: null,
      page: 1,
    },
    tags: {
      data: [],
      value: [],
      loader: false,
      error: null,
      page: 0,
    },
    candidates: {
      data: {
        items: [],
        meta: {},
      },
      value: [],
      loader: false,
      error: null,
      page: 0,
    },
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
      case GENERAL_SETTINGS_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          error: null,
        }
      case UPDATE_GENERAL_SETTINGS_REQUEST.INITIATE:
        return {
          ...state,
          loader: true,
          error: null,
          data: action.payload.data,
        }
      case GENERAL_SETTINGS_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data,
          loader: false,
        }
      case GENERAL_SETTINGS_REQUEST_ASYNC.ERROR:
      case UPDATE_GENERAL_SETTINGS_REQUEST.ERROR:
        return { ...state, error: action.error, loader: false }
      case GENERAL_SETTINGS_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case CHANGE_SELECTION_DATA:
        return {
          ...state,
          recipientList: {
            ...state.recipientList,
            selectionData: {
              ...state.recipientList.selectionData,
              [action.payload.field]: action.payload.value,
            },
          },
        }
      case GET_TAGS_ASYNC.INITIATE:
        return {
          ...state,
          tags: {
            ...state.tags,
            loader: true,
            error: null,
          },
        }
      case GET_TAGS_ASYNC.SUCCESS:
        return {
          ...state,
          tags: {
            ...state.tags,
            data:
              state.tags.page === 1
                ? action.payload.data.tags
                : [...state.tags.data, ...action.payload.data.tags],
            loader: false,
          },
        }
      case GET_TAGS_ASYNC.ERROR:
        return {
          ...state,
          tags: {
            ...state.tags,
            error: action.error,
            loader: false,
          },
        }
      case GET_TAGS_ASYNC.CANCEL:
        return {
          ...state,
          tags: {
            ...state.tags,
            loader: false,
          },
        }
      case GET_CANDIDATES_ASYNC.INITIATE:
        return {
          ...state,
          candidates: {
            ...state.candidates,
            loader: true,
            error: null,
          },
        }
      case GET_CANDIDATES_ASYNC.SUCCESS:
        return {
          ...state,
          candidates: {
            ...state.candidates,
            data: {
              ...action.payload.data,
              items:
                state.candidates.page === 1
                  ? action.payload.data.items
                  : [...state.candidates.data.items, ...action.payload.data.items],
            },
            loader: false,
          },
        }
      case GET_CANDIDATES_ASYNC.ERROR:
        return {
          ...state,
          candidates: {
            ...state.candidates,
            error: action.error,
            loader: false,
          },
        }
      case GET_CANDIDATES_ASYNC.CANCEL:
        return {
          ...state,
          candidates: {
            ...state.candidates,
            loader: false,
          },
        }
      case SET_TAGS:
        return {
          ...state,
          tags: {
            ...state.tags,
            value: action.payload.data,
          },
        }
      case SET_CANDIDATES:
        return {
          ...state,
          candidates: {
            ...state.candidates,
            value: action.payload.data,
          },
        }
      case RESET_SIMULATOR:
        return {
          ...initialState,
        }
      case SET_CANDIDATES_PAGE:
        return {
          ...state,
          candidates: {
            ...state.candidates,
            page: action.payload.page,
          },
        }
      case SET_TAGS_PAGE:
        return {
          ...state,
          tags: {
            ...state.tags,
            page: action.payload.page,
          },
        }
      case GET_RECIPIENTS_ASYNC.INITIATE:
        return {
          ...state,
          recipientList: {
            ...state.recipientList,
            loader: true,
            error: null,
          },
        }
      case GET_RECIPIENTS_ASYNC.SUCCESS:
        return {
          ...state,
          recipientList: {
            ...state.recipientList,
            // Consumers read data.items (mapped) and data.meta.count (pagination);
            // default both so a malformed/empty payload keeps the shape and the
            // list degrades to "empty" instead of crashing on `.meta.count`.
            data: { items: [], meta: {}, ...action.payload.data },
            loader: false,
            error: null,
          },
        }
      case GET_RECIPIENTS_ASYNC.ERROR:
        return {
          ...state,
          recipientList: {
            ...state.recipientList,
            error: action.error,
            loader: false,
          },
        }
      case GET_RECIPIENTS_ASYNC.CANCEL:
        return {
          ...state,
          recipientList: {
            ...state.recipientList,
            loader: false,
            error: null,
          },
        }
      case ADD_RECIPIENT_ASYNC.INITIATE:
      case REMOVE_RECIPIENT_ASYNC.INITIATE:
        return {
          ...state,
          recipientList: {
            ...state.recipientList,
            loader: true,
            error: null,
          },
        }
      case SET_RECIPIENTS_PAGE:
        return {
          ...state,
          recipientList: {
            ...state.recipientList,
            page: action.payload.page,
            loader: true,
          },
        }
      default:
        return state
    }
  }
}
